import { render, staticRenderFns } from "./shareChild.vue?vue&type=template&id=0d3e5492&scoped=true&"
import script from "./shareChild.vue?vue&type=script&lang=js&"
export * from "./shareChild.vue?vue&type=script&lang=js&"
import style0 from "./shareChild.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shareChild.vue?vue&type=style&index=1&id=0d3e5492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e5492",
  null
  
)

export default component.exports